<script setup>
import { ref, onMounted, reactive, computed, defineEmits, } from 'vue'
import GuideStep from './GuideStep.vue';
import { gApp } from '../Globals.js'

let proj = computed(() => {
  return gApp.proj();
})

let props = defineProps({
})

</script>

<template>
  <div>
    <div class="mb-l GuideHeader">
      <div class="GuideHeaderIcon"><i class="bi-clipboard-check"></i></div>
      <div class="GuideHeaderContent">
        <h2 class="GuideTitle">Project Guide</h2>
        <p class="Bold GuideSubtitle">Follow this guide to calculate loads</p>
      </div>
    </div>
    <GuideStep :stepNumber="1" :state="proj.guide" class="mb-xs">
      <template v-slot:content>
        <p class="mb-m CharW GoToTabText">
          Go to the <b>Build House</b> tab on the left to enter your house's info.
        </p>
      </template>
    </GuideStep>
    <GuideStep :stepNumber="2" :state="proj.guide" class="mb-xs">
      <template v-slot:content>
        <p class="mb-s GoToTabText">
          Go to the <b>Results</b> tab on the left to calculate loads.
        </p>
      </template>
    </GuideStep>
    <div class="CompletionMessage mt-m" v-if="proj.guide.allDone()">
      <p class="CompletionTitle">
        You've completed the guide.
      </p>
    </div>
    <div v-if="gApp.isAdminUser()" class="mt-m">
      <p>ADMIN SECTION</p>
      <button @click="proj.resetGuide()">Reset Guide</button>
    </div>
  </div>
</template>

<style scoped>
.MinorWarningSection {
  /*
  border: 1px solid var(--b-20);
  padding: var(--s);
  border-radius: var(--br-s);
  */
  border-left: 4px solid var(--b-20);
  padding-left: var(--xs);
  /*padding-top: var(--xs);*/
  padding-bottom: var(--xs);
}

.LockedStepMessage {
  color: var(--grey-40);
  font-style: italic;
}

.GuideHeader {
  background-color: var(--pc-10);
  padding: var(--m);
  border-radius: var(--br-s);
  border-left: 6px solid var(--pc);
  display: flex;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: var(--m);
}

.GuideHeaderIcon {
  font-size: 2rem;
  color: var(--pc);
  margin-right: var(--m);
  display: flex;
  align-items: center;
  justify-content: center;
}

.GuideHeaderContent {
  flex: 1;
}

.GuideTitle {
  font-size: 1.8rem;
  margin-bottom: var(--xxs);
  line-height: 1.2;
}

.GuideSubtitle {
  font-size: 1.1rem;
  margin: 0;
  color: var(--grey-40);
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
.GoToTabText {
  font-size: var(--f-l);
  font-weight: 500;
}
.StepText {
  font-size: var(--f-l);
}
.GuideStepText {
  font-size: var(--f-l);
}

.CompletionMessage {
  background-color: var(--pc-lightest);
  border-radius: var(--br-s);
  padding: var(--s);
  text-align: center;
  border: 1px solid var(--pc-light);
  animation: fadeInCompletion 0.8s ease-in-out forwards;
}

@keyframes fadeInCompletion {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.CompletionTitle {
  color: var(--pc);
  font-size: var(--f-l);
  font-weight: bold;
  line-height: 1.2;
}
</style>
